<template>
  <main class="main" role="main">
    <div class="main_con">
      <slot name="titleArea"></slot>
      <slot name="topArea"></slot>

      <div class="form_wrap">
        <div class="form">
          <ul class="form_ul">
            <li class="form_li">
              <div class="form_ttl">
                <div class="auth_form_title">
                  {{ formTitle }}
                  <span class="form_ttl_sub">{{ formSubTitle }}</span>
                  <div class="form_ttl_txt">{{ formSubTxt }}</div>
                </div>
              </div>
              <div class="form_in" v-if="isShowMobile || authType !== 'SMS'">
                <div class="inline">
                  <label class="input"
                    ><input
                      name="phone_input"
                      :type="inputType"
                      v-model="model.inputValue"
                      :placeholder="input_value_placeholder"
                      maxlength="50"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    />
                  </label>
                  <button class="btn" @click="handleAuthReq()">
                    {{ authButtonLabel }}
                  </button>
                </div>
                <label class="time_count" v-if="isContentsView">
                  <input
                    type="number"
                    placeholder="인증번호 입력"
                    v-model="model.authNumber"
                    @click="authNumberPosition"
                  />
                  <span class="time" :class="{ on: isStartCountdown }">{{
                    auth_number_placeholder
                  }}</span
                  ><!--'on 추가'-->
                </label>
                <p
                  class="valid"
                  :class="{ on: errormsg !== null && errormsg.length > 0 }"
                >
                  <i class="i_valid"></i>{{ errormsg }}
                </p>
                <!--'on 추가'-->
                <slot name="msgArea"></slot>
              </div>
              <slot
                name="kakaoLogin"
                v-if="isShowKakao && !isShowMobile"
              ></slot>

              <slot name="mobileLogin" v-if="!isShowMobile"></slot>

              <slot
                name="appleLogin"
                v-if="isShowApple && !isShowMobile && isAppVerChk"
              ></slot>

              <div
                class="form_ttl_btm_txt"
                v-if="isShowBtmMobile && !isShowMobile"
              >
                {{ formSubBtmTxt }}
              </div>
            </li>
          </ul>
          <div class="auth_btm_btn">
            <slot
              name="btnAreaLayer"
              :isAvailable="
                model.authNumber.length &&
                  model.inputValue.length &&
                  this.isStartCountdown
              "
              :isContentsView="isContentsView"
            ></slot>
          </div>
        </div>
        <countdown
          ref="countdown"
          :time="countdowntime"
          :auto-start="false"
          @progress="handleCountdownProgress"
          @start="handleCountdownStart"
          @abort="handleCountdownAbort"
          @end="handleCountdownEnd"
        >
        </countdown>
      </div>
      <!-- <div v-if="isExistBtnMsg"><br /></div> -->
    </div>
    <slot name="backButton" v-if="isShowMobile"></slot>
    <div class="auth_btm_btn">
      <slot
        name="btnArea"
        :isAvailable="
          model.authNumber.length &&
            model.inputValue.length &&
            this.isStartCountdown
        "
        :isContentsView="isContentsView"
      ></slot>
    </div>
    <div ref="dummy"></div>
  </main>
</template>
<script>
import { authMapActions, authTypes } from '@common/store/modules';
import { mapActions as userMapActions } from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  setReceiveCode,
  clearReceiveCode,
  showNativeToast,
  sleep,
  isApp,
  checkMobileOperatingSystem,
} from '@common/lib/common/utils';

import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';

export default {
  props: {
    authType: {
      type: String,
      default: 'SMS', // SMS, NONE, EMAIL
    },
    formTitle: {
      type: String,
      default: '휴대폰 번호로 간편하게 시작!',
    },
    isExistBtnMsg: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: 'GET',
    },
    formSubTitle: {
      type: String,
      default: '',
    },
    formSubTxt: {
      type: String,
      default: '',
    },
    formSubBtmTxt: {
      type: String,
      default: '',
    },
    // 휴대폰번호로그인 선택시 노출
    isShowMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      authButtonLabel: '인증번호 발송',
      countdowntime: 1000 * 60 * 3,
      //countdowntime: 1000 * 3, //for test
      isMounted: false,
      isStartCountdown: false,
      isConfirm: false,
      input_value_placeholder: '휴대폰번호(숫자만) 입력',
      auth_number_placeholder: '',
      errormsg: null,
      inputType: 'number',
      model: {
        authType: '',
        inputValue: '',
        authNumber: '',
        finalInputValue: '',
        finalAuthNumber: '',
      },
      isContentsView: false,
      isUserLoginPass: false, // 로그인 패스 (인증번호 문자 대신 alert창)
      isShowBtmMobile: true,
      isShowMobile2: false,
    };
  },

  mounted() {
    this.isMounted = true;
    this.model.authType = this.authType;
    this.title = this.formTitle;
    this.input_value_placeholder =
      this.authType === 'EMAIL'
        ? '이메일을 입력 해주세요'
        : this.input_value_placeholder;
    this.inputType = this.authType === 'EMAIL' ? 'text' : 'number';

    setReceiveCode(this.receiveCode);
  },
  beforeDestroy() {
    clearReceiveCode();
  },
  computed: {
    ...commonMapGetters({
      appInfo: commonGetters.APPINFO,
    }),
    AuthConfirmable() {
      if (!this.isMounted) return false;
      return this.isStartCountdown;
    },
    isShowKakao() {
      if (!isApp()) {
        return true;
      } else {
        if (checkMobileOperatingSystem() === 'iOS') {
          if (
            this.appInfo.appVersion == '1.1.5' &&
            parseFloat(this.appInfo.osVersion) >= 13
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
      // return checkMobileOperatingSystem() !== 'iOS';
    },
    isShowApple() {
      if (!isApp()) return false;
      return checkMobileOperatingSystem() === 'iOS';
    },
    // 애플로그인, 카카오로그인 버튼 os version 13.0 이상이어야 가능
    isAppVerChk() {
      if (parseFloat(this.appInfo.osVersion) >= 13) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...authMapActions([authTypes.AUTH_REQ, authTypes.AUTH_CONFIRM]),
    ...userMapActions([
      userTypes.EXIST_EMAIL,
      userTypes.FIND_USER_BY_MOBILE_NUMBER,
    ]),
    handleAuthValidate() {
      if (this.authType === 'SMS') {
        let regExp = /^\d{3}\d{3,4}\d{4}$/;

        if (!this.model.inputValue.length) {
          this.errormsg = '휴대폰 번호를 입력 해주세요.';
          this.$refs.countdown.abort();
          this.authButtonLabel = '인증번호 발송';
          return false;
        }

        if (
          !regExp.test(this.model.inputValue) ||
          !this.model.inputValue.length ||
          (this.model.inputValue.length !== 10 &&
            this.model.inputValue.length !== 11)
        ) {
          this.errormsg = '번호를 정상적으로 입력 해주세요.';
          this.$refs.countdown.abort();
          this.authButtonLabel = '인증번호 발송';
          return false;
        } else {
          const pass_num = this.model.inputValue.slice(0, 3);
          if (pass_num == '999') {
            this.isUserLoginPass = true;
          }
        }
      } else if (this.authType === 'EMAIL') {
        let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

        if (!this.model.inputValue.length) {
          this.errormsg = '이메일을 입력 해주세요.';
          this.$refs.countdown.abort();
          this.authButtonLabel = '인증번호 발송';
          return false;
        }

        if (!regExp.test(this.model.inputValue)) {
          this.errormsg = '이메일 양식에 맞게 입력 해주세요.';
          this.$refs.countdown.abort();
          this.authButtonLabel = '인증번호 발송';
          return false;
        }
      }

      this.errormsg = '';
      this.isShowMobile2 = true;
      this.$emit('isShowMobile2', this.isShowMobile2);
      return true;
    },
    async authNumberPosition() {
      await sleep(500);
      this.$refs.dummy.scrollIntoView({ behavior: 'smooth' });
    },
    handleAuthReq() {
      if (!this.handleAuthValidate()) return;
      this.$emit('additionalValidate');
      if (this.authType === 'EMAIL' && this.actionType === 'GET') {
        this[userTypes.EXIST_EMAIL](this.model.inputValue)
          .then(msg => {
            this.errormsg = '해당 이메일로 등록된 계정이 없습니다.';
            showNativeToast(this.errormsg, true);
          })
          .catch(err => {
            this[authTypes.AUTH_REQ](this.model).then(msg => {
              this.isConfirm = false;
              this.$refs.countdown.end();
              this.$refs.countdown.totalMilliseconds = this.countdowntime;
              this.$refs.countdown.start();
              this.model.authNumber = '';
              this.errormsg = '인증번호가 발송 되었습니다.';
              this.authButtonLabel = '재발송';
              this.isContentsView = true;

              //if (msg && process.env.NODE_ENV !== 'production') {
              //alert(msg.message);
              showNativeToast(this.errormsg, true);
              //}
            });
          });
      } else if (this.authType === 'EMAIL' && this.actionType === 'SET') {
        this[userTypes.EXIST_EMAIL](this.model.inputValue)
          .then(msg => {
            this[authTypes.AUTH_REQ](this.model).then(msg => {
              this.isConfirm = false;
              this.$refs.countdown.end();
              this.$refs.countdown.totalMilliseconds = this.countdowntime;
              this.$refs.countdown.start();
              this.model.authNumber = '';
              this.errormsg = '인증번호가 발송 되었습니다.';
              this.authButtonLabel = '재발송';
              this.isContentsView = true;

              //if (msg && process.env.NODE_ENV !== 'production') {
              //alert(msg.message);
              showNativeToast(this.errormsg, true);
              //}
            });
          })
          .catch(err => {
            this.errormsg = '이미 사용중인 이메일 주소 입니다.';
            showNativeToast(this.errormsg);
          });
      } else if (this.authType === 'SMS' && this.actionType === 'GET') {
        this[authTypes.AUTH_REQ](this.model).then(msg => {
          this.isConfirm = false;
          this.$refs.countdown.end();
          this.$refs.countdown.totalMilliseconds = this.countdowntime;
          this.$refs.countdown.start();
          this.model.authNumber = '';
          this.errormsg = '인증번호가 발송 되었습니다.';
          this.authButtonLabel = '재발송';
          this.isContentsView = true;
          //검수를 위한 임시
          if (this.model.inputValue === '01012341234' || this.isUserLoginPass) {
            alert(msg.message);
          }

          //if (msg && process.env.NODE_ENV !== 'production') {
          //alert(msg.message);
          showNativeToast(this.errormsg, true);

          this.authNumberPosition();

          //}
        });
      } else if (this.authType === 'SMS' && this.actionType === 'SET') {
        this[userTypes.FIND_USER_BY_MOBILE_NUMBER](this.model.inputValue)
          .then(() => {
            this.errormsg = '이미 가입된 휴대폰 번호 입니다.';
            showNativeToast(this.errormsg, true);
          })
          .catch(() => {
            this[authTypes.AUTH_REQ](this.model).then(msg => {
              this.isConfirm = false;
              this.$refs.countdown.end();
              this.$refs.countdown.totalMilliseconds = this.countdowntime;
              this.$refs.countdown.start();
              this.model.authNumber = '';
              this.errormsg = '인증번호가 발송 되었습니다.';
              this.authButtonLabel = '재발송';
              this.isContentsView = true;

              //if (msg && process.env.NODE_ENV !== 'production') {
              //alert(msg.message);
              showNativeToast(this.errormsg, true);
              //}
            });
          });
      }
    },
    handleCountdownProgress(data) {
      let { minutes, seconds } = data;
      seconds = seconds < 10 ? `0${seconds}` : seconds;
      this.auth_number_placeholder = `입력 시간 ${minutes}:${seconds}`;
      this.auth_number_placeholder = `${minutes}:${seconds}`;
    },
    handleCountdownStart() {
      this.isStartCountdown = true;
    },
    handleCountdownEnd() {
      this.isConfirm = false;
      this.isStartCountdown = false;
      this.auth_number_placeholder = '0:00';
      this.errormsg = '인증번호가 만료되었습니다';
      showNativeToast(this.errormsg, true);
    },
    handleCountdownAbort() {
      this.isStartCountdown = false;
    },
    receiveCode(code) {
      this.model.authNumber = code;
    },
    handleAuthConfirm(callback) {
      if (!this.AuthConfirmable) return;
      if (this.isUserLoginPass) {
        this.model.inputValue = '010' + this.model.inputValue.slice(3);
      }
      this[authTypes.AUTH_CONFIRM](this.model)
        .then(() => {
          this.isConfirm = true;
          this.model.finalInputValue = this.model.inputValue;
          this.model.finalAuthNumber = this.model.authNumber;
          this.$refs.countdown.abort();
          callback(this.model.inputValue, this.model.authNumber);
          //this.pushToken();
        })
        .catch(msg => {
          this.isConfirm = false;
          this.errormsg = '인증번호가 일치하지 않습니다.';
          showNativeToast(this.errormsg);
        });
    },
    getSuccess() {
      return (
        this.isConfirm &&
        this.model.finalInputValue === this.model.inputValue &&
        this.model.finalAuthNumber === this.model.authNumber
      );
    },
  },
};
</script>
